import { render, staticRenderFns } from "./AllDdjsEducation.vue?vue&type=template&id=1acf5f4e&scoped=true&"
import script from "./AllDdjsEducation.vue?vue&type=script&lang=js&"
export * from "./AllDdjsEducation.vue?vue&type=script&lang=js&"
import style0 from "./AllDdjsEducation.vue?vue&type=style&index=0&id=1acf5f4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acf5f4e",
  null
  
)

export default component.exports